import { HTMLAttributes, forwardRef } from 'react';

import { cn } from '@/lib/utils';

type Fill = 'paper' | 'ink' | 'lost' | 'found' | 'solved' | 'urgent';

export interface NbChipProps extends HTMLAttributes<HTMLSpanElement> {
  fill?: Fill;
  active?: boolean;
}

const FILL_CLASS: Record<Fill, string> = {
  paper: 'fill-paper',
  ink: 'fill-ink',
  lost: 'fill-lost',
  found: 'fill-found',
  solved: 'fill-solved',
  urgent: 'fill-urgent',
};

export const NbChip = forwardRef<HTMLSpanElement, NbChipProps>(
  ({ fill = 'paper', active = false, className, children, ...rest }, ref) => (
    <span
      ref={ref}
      className={cn('nb-chip', active ? 'fill-ink' : FILL_CLASS[fill], className)}
      {...rest}
    >
      {children}
    </span>
  ),
);
NbChip.displayName = 'NbChip';
